import { COLORS, TYPOGRAPHY } from '@app/constants';
import { FC } from 'react';
import { components, ControlProps } from 'react-select';
import styled from 'styled-components';

const Control: FC<ControlProps> = ({ children, ...props }) => {
  const { error, menuIsOpen } = props.selectProps;

  return (
    <components.Control {...props}>
      <Root $isOpened={menuIsOpen} $hasError={!!error?.length}>
        {children}
      </Root>
    </components.Control>
  );
};

export default Control;

interface StyleProps {
  $isOpened: boolean;
  $hasError: boolean;
}

const Root = styled.div<StyleProps>`
  ${TYPOGRAPHY.body1Regular14}

  color: ${COLORS.black800};
  padding: 11px 16px;
  display: flex;
  width: 100%;
  border-radius: 10px;
  cursor: pointer;

  --border-color: ${({ $isOpened }) =>
    $isOpened ? COLORS.primary300 : COLORS.grayscale100};
  border: 1px solid
    ${({ $hasError }) =>
      $hasError ? COLORS.systemError : 'var(--border-color)'};

  &:hover {
    --border-color: ${({ $isOpened }) => !$isOpened && COLORS.grayscale200};
  }
`;
